/*
  Shop mega-menu — keep the active secondary panel pinned to the top of the visible
  menu as the level-1 parent list scrolls underneath it.

  The secondary panels are position:absolute overlapping layers inside the scrolling
  `.mega-nav--sidebar` (only the hovered parent's panel is visible; the rest are
  visibility:hidden). Because they're absolute, CSS `position: sticky` can't hold
  them — forcing them in-flow un-stacks the menu (it ballooned to ~6000px in
  testing). Instead, set the ACTIVE panel's `top` to the sidebar's scrollTop on
  scroll and whenever the hovered parent changes, so the secondary items always
  start at the top of the visible menu regardless of how far the left list is
  scrolled. Paired with a hidden scrollbar on the left list (llm-header.css).

  Desktop only in practice: `.mega-nav--sidebar` is the desktop mega-menu; mobile
  uses a separate drawer with no hover, so nothing here binds there.
*/
(function () {
  function pin(sidebar) {
    // Pin ALL panels (not just the currently-visible one) to the scroll offset, so
    // whichever parent you hover next is already anchored to the top. Pinning only
    // the active panel left a gap: on hover the newly-activated panel wasn't yet the
    // "visible" one, so it stayed at its unpinned spot (only its bottom in view) until
    // the next event re-pinned it. The inactive panels are hidden, so moving them is
    // invisible.
    var top = sidebar.scrollTop + 'px';
    var panels = sidebar.querySelectorAll('.child-nav__panel');
    for (var i = 0; i < panels.length; i++) {
      panels[i].style.top = top;
    }
  }

  function bind(sidebar) {
    if (sidebar.dataset.llmPinBound) return;
    sidebar.dataset.llmPinBound = '1';

    var raf = 0;
    var schedule = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        pin(sidebar);
      });
    };

    sidebar.addEventListener('scroll', schedule, { passive: true });
    // The visible panel changes as you move between level-1 parents — re-pin.
    sidebar.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest('.child-nav__item--toggle')) schedule();
    }, { passive: true });

    pin(sidebar);
  }

  // The mega-menu markup is in the DOM even while closed, so bind up front.
  function scan() {
    document.querySelectorAll('.mega-nav--sidebar').forEach(bind);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  // Fallback for any sidebar added/hydrated later: bind on first pointer entry.
  document.addEventListener('mouseover', function (e) {
    var sb = e.target.closest && e.target.closest('.mega-nav--sidebar');
    if (sb) bind(sb);
  }, { passive: true });
})();
